import { Base, Component, Inject, Mixins } from '@/vue-property-decorator'
import { GetCssVarManager } from '@/views/game/components/gameCardSuit/components/baseCssVarProvide'
import { LandscapeProps } from '../../components/basePropsConfig'
import { _OuterBoxBase as OuterBoxBase } from './cssVar/outerBoxBase'
import { _OuterBoxDefault as OuterBoxDefault } from './cssVar/outerBoxDefault'
import { _OuterBoxSmall as OuterBoxSmall } from './cssVar/outerBoxSmall'
import BaseCssVarInject from '../../../../components/baseCssVarInject'
import style from './style.module.scss'
export type OuterBoxCssVarManager = GetCssVarManager<OuterBoxBase>
export { OuterBoxBase, OuterBoxDefault, OuterBoxSmall }
/** 游戏卡片-横向卡片 */
@Component<OuterBox>({
  name: 'OuterBox'
})
export default class OuterBox extends Mixins<
  Base<unknown, unknown, { onClick: () => void }>,
  BaseCssVarInject<OuterBoxBase>
>(Base, BaseCssVarInject) {
  /** 获得默认样式 */
  public static getCssVarDefault = () => new OuterBoxDefault()
  /** 获得小号样式 */
  public static getCssVarSmall = () => new OuterBoxSmall()

  @Inject() cardProps!: Required<LandscapeProps>
  // 渲染入口.
  render() {
    const { isAtSwiper, atSwiperDomId } = this.cardProps
    return (
      // 最外层的这个div,其主要还是预留给list盒子操作它的样式
      <div
        class={{
          [style['outer-box']]: true,
          [style[`type-${this.finialCssType}`]]: Boolean(this.finialCssType)
        }}
      >
        {/* outer-box-main 才是主要样式开始的地方 */}
        <my-img
          options={{
            type: 'div',
            lazy: !isAtSwiper,
            immediate: isAtSwiper
          }}
          src=""
          syncGroupsSrc={isAtSwiper}
          syncGroupsWrapId={atSwiperDomId}
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          //@ts-ignore
          role="OuterBox"
          onClick={() => this.$emit('click')}
          class={{
            [style['outer-box-main']]: true,
            ['outer-box-main']: true
          }}
        >
          {this.$slots.default}
        </my-img>
      </div>
    )
  }
}
